var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import styled from 'styled-components';
import Typography from '../../Styles/Typography/Typography';
const TabsStyle = styled.div `
  display: flex;
  box-sizing: border-box;
  position: relative;
  width: ${props => props.width};
`;
const LabelsContainer = styled.div `
  position: relative;
  width: inherit;
  z-index: 1;
  display: flex;
  justify-content: flex-start;
  background-color: ${props => props.theme.utils.getColor(props.backgroundColor)};
  padding-top: ${props => props.theme.paddingsMargins.themeMenuPaddingSingle};
  padding-left: ${props => props.theme.paddingsMargins.themePaddingLargeSingle};
  padding-right: ${props => props.theme.paddingsMargins.themePaddingLargeSingle};
  padding-bottom: ${props => props.theme.paddingsMargins.themeMenuMarginSingle};
  align-items: center;
  box-shadow: ${(props) => props.noShadow ? '0' : props.theme.boxes.boxShadow};
  border-top-left-radius: ${(props) => props.labelsBorderRadius ? props.theme.borders.borderRadius : 0};
  border-top-right-radius: ${(props) => props.labelsBorderRadius ? props.theme.borders.borderRadius : 0};
  overflow-x: scroll;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  &::-webkit-scrollbar {
    display: none;
  }
`;
const Label = styled.button `
  min-width: ${props => props.labelWidth};
  display: flex;
  justify-content: center;
  cursor: pointer;
  position: relative;
  background-color: transparent;
  box-sizing: border-box;
  border: none;
  padding-top: ${props => props.theme.paddingsMargins.themeMenuMarginSingle};
  padding-left: ${props => props.theme.paddingsMargins.themePaddingLargeSingle};
  padding-right: ${props => props.theme.paddingsMargins.themePaddingLargeSingle};
  padding-bottom: ${props => props.theme.paddingsMargins.themeMenuMarginSingle};
`;
const SpanSelection = styled.span `
padding-left: ${props => props.theme.paddingsMargins.themePaddingLargeSingle};
padding-right: ${props => props.theme.paddingsMargins.themePaddingLargeSingle};
  position: absolute;
  z-index: 2;
  height: 4px;
  background-color: ${props => props.theme.utils.getColor(props.color)};
  width: ${props => props.width + 'px'};
  bottom: 0;
  left: ${props => props.left + 'px'};
  transition: all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
`;
const Tabs = (_a) => {
    var { width = '100%', backgroundColor = 'mainLight', labelWidth = '10%', labelSize = 'subArticle', labelColor = '#fff', labelIndex, selectorColor = 'secondary', noShadow = false, containerWidth = false, customIndexValue = 0, onChange = () => { }, onChangeIndex = () => { }, labelsBorderRadius = true, isUnderline = true, labels } = _a, props = __rest(_a, ["width", "backgroundColor", "labelWidth", "labelSize", "labelColor", "labelIndex", "selectorColor", "noShadow", "containerWidth", "customIndexValue", "onChange", "onChangeIndex", "labelsBorderRadius", "isUnderline", "labels"]);
    const [currentIndex, setCurrentIndex] = useState(customIndexValue);
    const [selectorWidth, setSelectorWidth] = useState(0);
    const [selectorLeft, setSelectorLeft] = useState(0);
    const timestampID = new Date().getUTCMilliseconds();
    const labelsLength = labels.filter(value => value !== null).length;
    useEffect(() => {
        if (labelIndex !== undefined && labelIndex < labelsLength) {
            setCurrentIndex(labelIndex);
        }
        else if (labelIndex && labelIndex > labelsLength) {
            console.error("CRONO TABS: labelIndex can't be higher than total number of labels");
        }
    }, [labelIndex, labelsLength]);
    useEffect(() => {
        if ((labels[currentIndex] === undefined || labels[currentIndex] === null || labels[currentIndex] === '')) {
            console.error('CRONO TABS: Default current value in labels has a falsy value, moving to the next Tab to generate correct data');
            setCurrentIndex(currentIndex + 1);
        }
    }, [labelIndex, labelsLength]);
    useEffect(() => {
        const currentElement = document.getElementById('tab-label-' + currentIndex + timestampID);
        if (currentElement) {
            setSelectorWidth(currentElement.offsetWidth);
        }
        let left = 0;
        for (let i = 0; i < currentIndex; i++) {
            const toBeAdded = document.getElementById('tab-label-' + i + timestampID);
            if (toBeAdded) {
                left += toBeAdded.offsetWidth;
            }
            else {
                left += 0;
            }
        }
        setSelectorLeft(left);
    }, [currentIndex, timestampID]);
    const labelClick = (i) => {
        setCurrentIndex(i);
        onChange(i);
    };
    return (_jsxs(TabsStyle, Object.assign({ width: width }, props, { children: [_jsx(LabelsContainer, Object.assign({ backgroundColor: backgroundColor, noShadow: noShadow, labelsBorderRadius: labelsBorderRadius }, { children: labels.map((label, i) => _jsx(Label, Object.assign({ onClick: () => labelClick(i), style: { display: (label === null || label === '' || label === undefined) ? 'none' : 'flex' }, labelWidth: containerWidth ? 100 / labelsLength + '%' : labelWidth, id: 'tab-label-' + i + timestampID }, { children: _jsx(Typography, Object.assign({ size: labelSize, color: currentIndex === i ? selectorColor : labelColor, weight: currentIndex === i ? 'bold' : 'normal', overflowWrap: "anywhere" }, { children: label })) }), i)) })), isUnderline &&
                _jsx(SpanSelection, { color: selectorColor, width: selectorWidth, left: selectorLeft })] })));
};
export default Tabs;
